
import { GoogleMap, Marker } from "vue3-google-map";
import { defineComponent, ref, onMounted } from "vue";

export default defineComponent({
  components: { GoogleMap, Marker },
  props: {
    location: {
      type: Object,
    },
  },
  setup(props) {
    const location = ref(props.location);
    const mapCenter = ref();

    onMounted(() => {
      mapCenter.value = location.value;
    });
  },
});
